import React, { createContext, useContext, useEffect, useState } from "react";

const VideoSupportContext = createContext({ codec: "h264" }); // default to h264

export const useVideoSupport = () => useContext(VideoSupportContext);

const detectBrowserCodec = () => {
  const ua = navigator.userAgent;

  if (/Safari/.test(ua) && !/Chrome/.test(ua)) {
    return "h265"; // Safari supports h265
  }

  if (/Chrome/.test(ua) && !/Edg/.test(ua)) {
    return "h265"; // Chrome on macOS or newer versions may support h265
  }

  if (/Firefox/.test(ua)) {
    return "h264"; // Firefox does not support h265
  }

  if (/Edg/.test(ua)) {
    return "h264"; // ✅ Force h264 on Edge
  }

  return "h264"; // Default fallback
};


export const VideoSupportProvider = ({ children }) => {
  const [codec, setCodec] = useState("h264");

  useEffect(() => {
    const selectedCodec = detectBrowserCodec();
    setCodec(selectedCodec);
  }, []);

  return (
    <VideoSupportContext.Provider value={{ codec }}>
      {children}
    </VideoSupportContext.Provider>
  );
};

export default VideoSupportProvider;
